import React, { useState, useEffect } from "react";
import { LoginInputField, RequestOtpBtn, mtCustomerSubscribeToPayload } from "./Common";
import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames/bind";
import { ClearCusInfo, formsCusInfoDataChange, addObjToCriteriaList } from "../stores/loginSlice";
import { postApiDataAsync, kloader } from "../common/Common";
import Config from "config";

export const Register = (props) => {
  const [customerInfo] = useSelector((state) => [state.login.customerInfo]);
  const [submitEnable, setSubmitEnable] = useState(false);
  const dispatch = useDispatch();
  const validateField = ["email", "otp", "fullName", "phone"];

  useEffect(() => {
    //For otpref and otpID
    dispatch(ClearCusInfo());
  }, []);

  function requestOtp(e) {
    console.log("request otp");
    kloader();

    postApiDataAsync({
      urlPath: "/SendEmailOtp",
      objRequest: {
        request: {
          MailTO: customerInfo.email.value,
        },
      },
    })
      .then((data) => {
        console.log("data", data);
        dispatch(formsCusInfoDataChange({ field: "otpRef", value: data.OTPReference }));
        dispatch(formsCusInfoDataChange({ field: "otpID", value: data.VerifyOtpID }));

        props.showPop("กรุณาเช็คอีเมลเพื่อรับรหัส OTP");
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "INVALID_OTP":
            props.showPop("รหัส OTP ไม่ถูกต้อง");
            break;
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
      });
  }

  const handleKeyDownEmail = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      requestOtp();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (submitEnable) {
        props.submit("Login");
      }
    }
  };

  return (
    <>
      <div className="container container-large">
        <div className="content">
          <h1>ลงทะเบียนเพื่อรับอีเมลทรัพย์มือสองแนะนำ</h1>
          <h2 className="sub-title">
            กรอกรายละเอียดทรัพย์
            <br className="show-xs" /> และทำเลที่สนใจ
          </h2>
          <div className="inner-content">
            <LoginInputField
              {...customerInfo.fullName}
              validateField={validateField}
              setSubmitEnable={setSubmitEnable}
            />
            <LoginInputField
              {...customerInfo.phone}
              validateField={validateField}
              setSubmitEnable={setSubmitEnable}
            />
            <LoginInputField
              {...customerInfo.email}
              additionBtn={<RequestOtpBtn onClick={requestOtp} />}
              validateField={validateField}
              setSubmitEnable={setSubmitEnable}
              onKeyDown={handleKeyDownEmail}
            />
            <LoginInputField
              {...customerInfo.otp}
              validateField={validateField}
              setSubmitEnable={setSubmitEnable}
              onKeyDown={handleKeyDown}
            />
            <div className="remark">
              ธนาคารจะเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อติดต่อ{" "}
              <br className="hide-xs" />
              นำเสนอและประชาสัมพันธ์ผลิตภัณฑ์และบริการที่คุณสนใจ โปรดศึกษา{" "}
              <br className="hide-xs" />
              รายละเอียดและสิทธิใน{" "}
              <a href="https://kbank.co/PDPA_TH_WEBSITE" className="link">
                นโยบายการคุ้มครองข้อมูลส่วนบุคคล
              </a>
            </div>
            <div className="box-btn">
              <a
                href={void 0}
                onClick={(e) => props.submit("Register")}
                className={classnames(["btn-green mousePointer", { disable: !submitEnable }])}
              >
                บันทึก
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
